import React, {lazy, Suspense, useState} from 'react';
import "./BottomBanner.scss";

const BottomBanner = (props) => {
  const [attributes, setAttributes] = useState(props)
  let ComponentLazy = null;

  if(attributes.page === "moka") { ComponentLazy = lazy(() => import("./Content/Moka"));}

  return (
    <div className="BottomBanner col-xs-12" id='BottomBanner'>
      <Suspense fallback={<div>Loading...</div>}>
        <ComponentLazy attributes={props}/>
      </Suspense>
    </div>
  )
}
export default BottomBanner;
